/* ==========================================================
   CORE ENGINE. injected verbatim per V2 spec. Do not edit.
   ========================================================== */
// Base Configuration Tables
const pythagorean = {"A":1,"B":2,"C":3,"D":4,"E":5,"F":6,"G":7,"H":8,"I":9,"J":1,"K":2,"L":3,"M":4,"N":5,"O":6,"P":7,"Q":8,"R":9,"S":1,"T":2,"U":3,"V":4,"W":5,"X":6,"Y":7,"Z":8};
const chaldean = {"A":1,"I":1,"J":1,"Q":1,"Y":1,"B":2,"K":2,"R":2,"C":3,"G":3,"L":3,"S":3,"D":4,"M":4,"T":4,"E":5,"H":5,"N":5,"X":5,"U":6,"V":6,"W":6,"O":7,"Z":7,"F":8,"P":8};
const primes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199];
const systemGovernors = {
    1: "The Source Architect", 2: "The Transition Processor", 3: "The Truth Sensor",
    4: "The Boundary Matrix", 5: "The Liquidity Stream", 6: "The Kinetic Engineer",
    7: "The Bio-Logic Expert", 8: "The Randomness Vector", 9: "The Signal Broadcaster",
    10: "The Execution Logic", 11: "The Volatility Handler", 12: "The Junction Gatekeeper"
};

function getSum(str, dict) {
    let sum = 0;
    for (let i = 0; i < str.length; i++) { sum += dict[str[i]] || 0; }
    return sum;
}

// 100% Deterministic V2 Engine Function
function executeDivinetixEngineV2(firstInput, middleInput, lastInput) {
    const first = firstInput.toUpperCase().replace(/[^A-Z]/g, "");
    const middle = middleInput.toUpperCase().replace(/[^A-Z]/g, "");
    const last = lastInput.toUpperCase().replace(/[^A-Z]/g, "");
    const fullName = first + middle + last;

    if (!first || !last) return null;

    // Static Metrics
    const firstSum = getSum(first, pythagorean);
    const lastSum = getSum(last, pythagorean);
    const totalSum = getSum(fullName, pythagorean);

    let seed = firstSum % 9; if (seed === 0) seed = 9;
    let potential = lastSum % 22; if (potential === 0) potential = 22;
    let root = totalSum % 12; if (root === 0) root = 12;

    let chaldeanSum = getSum(fullName, chaldean);
    while (chaldeanSum > 9) {
        chaldeanSum = chaldeanSum.toString().split('').reduce((a, b) => parseInt(a) + parseInt(b), 0);
    }
    const truthHunter = chaldeanSum;
    const assetType = primes.indexOf(totalSum) > -1 ? "Fixed Asset" : "Liquid Asset";

    let vowels = 0; let consonants = 0;
    const vowelList = ['A','E','I','O','U'];
    for (let i = 0; i < fullName.length; i++) {
        if (vowelList.indexOf(fullName[i]) > -1) { vowels += pythagorean[fullName[i]]; }
        else { consonants += pythagorean[fullName[i]]; }
    }
    const baseRatio = consonants === 0 ? 0 : parseFloat((vowels / consonants).toFixed(2));

    // Dynamic Temporal Moon Layer Execution
    const submissionTimestamp = Date.now();
    const knownNewMoon = 947182440000; // Reference point: Jan 6, 2000 18:14 UTC
    const synodicMonthMs = 29.530588 * 24 * 60 * 60 * 1000;
    const elapsed = submissionTimestamp - knownNewMoon;
    const cyclesElapsed = elapsed / synodicMonthMs;
    const phasePosition = cyclesElapsed - Math.floor(cyclesElapsed);

    let moonModifier = 0;
    let phaseName = "";
    if (phasePosition < 0.0625 || phasePosition >= 0.9375) { moonModifier = -0.15; phaseName = "New Moon (Deepest Contraction)"; }
    else if (phasePosition < 0.1875) { moonModifier = -0.08; phaseName = "Waxing Crescent"; }
    else if (phasePosition < 0.3125) { moonModifier = -0.03; phaseName = "First Quarter"; }
    else if (phasePosition < 0.4375) { moonModifier = +0.03; phaseName = "Waxing Gibbous"; }
    else if (phasePosition < 0.5625) { moonModifier = +0.15; phaseName = "Full Moon (Deepest Expansion)"; }
    else if (phasePosition < 0.6875) { moonModifier = +0.05; phaseName = "Waning Gibbous"; }
    else if (phasePosition < 0.8125) { moonModifier = -0.03; phaseName = "Last Quarter"; }
    else { moonModifier = -0.08; phaseName = "Waning Crescent"; }

    const activeRatio = parseFloat((baseRatio + moonModifier).toFixed(2));
    
    let activeFace = "Third Face";
    if (activeRatio > 1.0) activeFace = "Loud Expression";
    if (activeRatio < 0.85) activeFace = "Quiet Expression";

    return {
        seed, potential, root, truthHunter, assetType, baseRatio,
        phasePosition: phasePosition.toFixed(4), phaseName, activeRatio, activeFace,
        governor: systemGovernors[root]
    };
}
/* ================= END CORE ENGINE ================= */


/* ==========================================================
   PREVIEW CONTENT. placeholder Ledger copy, keyed by Root.
   Swap each entry with the real Branch preview text.
   ========================================================== */
const rootPreviews = {
  1:{ledger:"THE INVISIBLE LEDGER", storage:"Head & Crown",
     carry:"You walk into rooms and feel like an apology. You make yourself smaller before anyone asks you to: present without being noticed, fluent in disappearing. And when someone finally does see you, it feels dangerous, like visibility might cost you something. It once did. Not to you.",
     debt:"The Erasure Debt. Somewhere in your line, staying small kept people alive. They hid their names, their faces, their size. That survival code got recorded in the Ledger and delivered to you as a personality. It isn't one."},
  2:{ledger:"THE EMPTY LEDGER", storage:"Stomach & Gut",
     carry:"There's never enough. Time, money, love, attention. You move through life with a running calculator, always counting what's missing. Even in the good stretches, part of you is bracing. You don't trust abundance because your system has never been shown what settled feels like.",
     debt:"The Scarcity Debt. Someone upstream survived on rationing, of food, of affection, of hope, and the ration became the recipe. You inherited the counting, not the famine. The famine ended. The counting didn't."},
  3:{ledger:"THE SILENT LEDGER", storage:"Throat & Neck",
     carry:"You know exactly what you want to say. You've rehearsed it word for word. Then the moment arrives and something intercepts it. Your voice flattens, the words dissolve, and you spend the drive home replaying the sentence you didn't say. That interception is not shyness. It's a lock.",
     debt:"The Persecution Debt. In your line, the truth got someone punished for speaking, for naming, for being right out loud. The lock on your throat was installed as protection. The threat is gone. The lock is still holding."},
  4:{ledger:"THE DISPLACED LEDGER", storage:"Heart & Chest / Feet",
     carry:"Part of you has never fully unpacked. Not your boxes. Your heart. You can live somewhere for years and something in you stays ready to leave. You've called many places home and believed none of them, because belief requires roots and your system files roots under risk.",
     debt:"The Displacement Debt. Your line lost ground: land, country, standing, a place at the table. It learned that attachment to place is how you get hurt. You inherited the packed bag. Nobody's coming to take the ground anymore."},
  5:{ledger:"THE FROZEN LEDGER", storage:"Sacral / Lower Back / Hips",
     carry:"You've forgotten how to celebrate. Good things happen. But somewhere between the event and the feeling, something freezes. Joy starts to move and guilt intercepts it, as if enjoying this moment means betraying someone who never got one. So you achieve, and then you go quiet.",
     debt:"The Joy Debt. Somewhere upstream, celebration was unaffordable, or dangerous. Grief took the seat joy was meant to sit in and never gave it back. You've been paying respect to a mourning that isn't yours to hold."},
  6:{ledger:"THE OVERLOADED LEDGER", storage:"Whole Body / Muscles",
     carry:"You're tired. Not the kind sleep fixes. The kind that lives in the bones. You've been pushing, building, clearing, carrying, and your body has quietly become a machine, and machines don't get to rest. Rest, in your system, has to be earned. The invoice never clears.",
     debt:"The Labor Debt. Your line paid for existence in work. Worth was output, safety was productivity, stopping was danger. That pricing model was billed forward to you. You are still paying a debt that was settled before you were born."},
  7:{ledger:"THE FRACTURED LEDGER", storage:"Digestive System / Cellular",
     carry:"You've been broken before. Not hurt. Fractured. Something that was supposed to hold came apart: a family, a bond, a version of yourself. And even 'healed,' you build everything now with one hand on the exit, stress-testing every good thing for the crack you're sure is in it.",
     debt:"The Fracture Debt. A break upstream never got set properly, so your line learned to pre-break things: leave first, doubt first, brace first. You inherited the flinch, not the fracture. What you're protecting against already happened. To someone else."},
  8:{ledger:"THE UNSEEN LEDGER", storage:"Third Eye / Nervous System",
     carry:"You're carrying a high-definition signal in a low-resolution world. You don't notice things. You SEE them: patterns in chaos, meaning in coincidence, the warning before it lands. And you've learned to say it softly or not at all, because seeing clearly has never made you popular.",
     debt:"The Seer's Debt. Someone in your line saw truly and paid for it: dismissed, feared, or worse. So the signal stayed but the broadcast was cut. You've been receiving at full strength and transmitting at zero."},
  9:{ledger:"THE SEVERED LEDGER", storage:"Voice / Transmission / Crown",
     carry:"You have something to say. Something that could actually help people. But the transmission keeps failing. You speak and no one hears, you create and no one sees, and every failed send confirms the quiet suspicion that the line was cut before you ever picked it up. It was. Not by you.",
     debt:"The Transmission Debt. Somewhere in your line, a voice was severed mid-sentence: silenced, exiled, unheard by design. The message survived; the channel didn't. You inherited a full inbox and a cut wire. The wire is repairable."},
  10:{ledger:"THE EXPOSED LEDGER", storage:"Skin / Boundaries / Presence",
     carry:"You live in a glass house while everyone else seems to be carrying stones. A spotlight you never asked for follows you. Every flaw feels visible, every mistake feels public, and privacy feels like something other people get. You perform composure for an audience that may not even be watching.",
     debt:"The Exposure Debt. Your line was watched: judged, made an example of, denied the right to a private self. Surveillance got recorded as weather: just how the sky is. It isn't. Most of the eyes you feel are inherited, not present."},
  11:{ledger:"THE EXILED LEDGER", storage:"Extremities / Circulation",
     carry:"You've always been the misfit, never quite fitting the family, the group, the system you were born into. You walk into a room and calculate the nearest exit, not from fear but from a lifetime of knowing that belonging, for you, has always come with conditions you couldn't meet.",
     debt:"The Exile Debt. Someone in your line was cast out, from a family, a land, a people, and the banishment was filed as identity. You've been pre-exiling yourself ever since: leaving before you're left. Nobody is voting you off anymore."},
  12:{ledger:"THE FLOODED LEDGER", storage:"Nervous System / Crossroads",
     carry:"You're drowning in a world that hasn't even rained yet. You feel everything. Not just your emotions, everyone's. You walk into a room and instantly know who's fighting, who's lying, who's hurting, and your system takes it all on as cargo. None of it gets sorted. All of it gets stored.",
     debt:"The Flood Debt. Your line had no levees. Feelings arrived as weather systems, unnamed and unprocessed, and someone had to absorb them. That someone became a role, and the role became yours. Absorbing was never the assignment. Sorting is."}
};

const faceNotes = {
  "Loud Expression":"Your outward channel is running above baseline right now. The system is broadcasting. Visibility, output, and friction are all amplified in this window.",
  "Quiet Expression":"Your system is running below baseline right now. The active field favors withdrawal, consolidation, and internal processing over output.",
  "Third Face":"Your system is holding the mid-band, neither broadcast nor withdrawal. This is the observation window: the Face that watches the other two."
};

// Client-facing field-state names, resolved from cycle position (mirrors engine bands).
function getFieldState(p) {
  if (p < 0.0625 || p >= 0.9375) return "DEEP CONTRACTION · FIELD FLOOR";
  if (p < 0.1875) return "EARLY ASCENT";
  if (p < 0.3125) return "FIRST THRESHOLD";
  if (p < 0.4375) return "BUILDING CHARGE";
  if (p < 0.5625) return "PEAK EXPANSION · FIELD CEILING";
  if (p < 0.6875) return "ACTIVE DISCHARGE";
  if (p < 0.8125) return "SECOND THRESHOLD";
  return "LATE DESCENT";
}

// V2.2 Face resolution. hybrid threshold fix. Spec thresholds preserved where
// they can move (base 0.70 to 1.15); outside that band the Face resolves relative
// to the signature's own baseline so every signature cycles all Three Faces.
function resolveActiveFace(r) {
  if (r.baseRatio > 0.70 && r.baseRatio < 1.15) return r.activeFace;
  const delta = parseFloat((r.activeRatio - r.baseRatio).toFixed(2));
  if (delta >= 0.05) return "Loud Expression";
  if (delta <= -0.08) return "Quiet Expression";
  return "Third Face";
}

const todaysWindow = {
  "Loud Expression":{verb:"ACT", cls:"w-act", line:"The field is amplifying whatever you put out. Ship the thing. Have the conversation. Send the message you drafted three weeks ago. What you start in this window carries extra charge, and so does what you avoid."},
  "Quiet Expression":{verb:"HOLD", cls:"w-hold", line:"The field is pulling inward. This is not the window to launch, confront, or commit. Close open loops. Finish, file, rest. Decisions made now favor elimination (what to stop), not expansion."},
  "Third Face":{verb:"OBSERVE", cls:"w-observe", line:"Mid-band. Neither push nor retreat. Gather data: watch what surfaces in you and around you, and write it down. Decide nothing irreversible until the field commits to a direction."}
};

/* ==========================================================
   UI CONTROLLER
   ========================================================== */
const $ = id => document.getElementById(id);
const stages = { input: $('stage-input'), proc: $('stage-proc'), gate: $('stage-gate'), dash: $('stage-dash') };
let gateDone = false;
let pendingRender = null;
let lastAudit = null; // { root, face } of the audit currently on screen, for the rating tally

/* SHEET ENDPOINT
   Paste the Google Apps Script web app URL between the quotes. It receives:
   ratings (to the Ratings tab: timestamp, rating, root, face) and email
   captures from the gate and save card (to the Leads tab: timestamp, type,
   email, root, name). Empty string = display-only, nothing sent.
   Setup steps and the doPost script are in docs/DEVELOPER-HANDOFF.md sec 7. */
const RATING_ENDPOINT = 'https://script.google.com/macros/s/AKfycbzQMjZod8-KOVev3-1pGJTTFM1Slhuh7OBnhlU7Nr6a9AMdrtM80eyArob-lFqBvnUn2A/exec';

function postToSheet(payload){
  if (!RATING_ENDPOINT) return;
  fetch(RATING_ENDPOINT, { method:'POST', mode:'no-cors',
    headers:{'Content-Type':'text/plain'}, body: JSON.stringify(payload) }).catch(function(){});
}
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function show(stage){
  Object.values(stages).forEach(s => s.classList.remove('active'));
  stages[stage].classList.add('active');
  window.scrollTo({top:0, behavior: reduceMotion ? 'auto' : 'smooth'});
}

$('noMiddle').addEventListener('change', e => {
  const m = $('mname');
  m.disabled = e.target.checked;
  if (e.target.checked) m.value = '';
});

const procSteps = [
  "Parsing Name Frequency Components...",
  "Calculating Static Karmic Coordinates (Mod 9 / Mod 22 / Mod 12)...",
  "Running Number-Theory Primality Checks...",
  "Extracting Base Vowel/Consonant Resonance Ratios...",
  "Capturing Live Submission Timestamp...",
  "Processing Temporal Field Coordinates & Applying Temperature Modifier...",
  "Compiling Active Ledger Face Expression..."
];
// step durations, ms (sums to ~9.6s; compressed under reduced motion)
const stepDur = [2400, 1400, 1200, 1200, 900, 1500, 1000];

/* Input filter: blocks profanity and slurs from reaching the engine or the
   shareable Signature Card. Exact-token matching only (no substrings), so
   real names that merely contain awkward letter runs are never rejected.
   Deliberately NOT blocked: celebrity names, places, unusual real names.
   The engine reads what it is given; play is allowed, abuse is not.
   Extend the list as needed. A server-side filter supersedes this in Phase 2. */
const BLOCKED = new Set(('FUCK FUCKER FUCKERS FUCKING MOTHERFUCKER SHIT SHITS SHITTY BULLSHIT BITCH BITCHES ASSHOLE ASSHOLES BASTARD CUNT CUNTS DICK DICKS DICKHEAD PUSSY PUSSIES COCK COCKS WHORE WHORES SLUT SLUTS DOUCHE DOUCHEBAG TWAT WANKER PRICK PISS JACKASS DUMBASS NIGGER NIGGERS NIGGA NIGGAS FAGGOT FAGGOTS FAG FAGS RETARD RETARDS RETARDED KIKE SPIC CHINK WETBACK TRANNY DYKE COON PENIS VAGINA TITS BOOBS ANAL CUM JIZZ BLOWJOB HANDJOB RIMJOB').split(' '));
function inputBlocked(raw){
  if (!raw) return false;
  const tokens = raw.toUpperCase().split(/[^A-Z]+/).filter(Boolean);
  const whole = raw.toUpperCase().replace(/[^A-Z]/g,'');
  if (BLOCKED.has(whole)) return true;
  for (const t of tokens) if (BLOCKED.has(t)) return true;
  return false;
}

$('runBtn').addEventListener('click', () => {
  const first = $('fname').value.trim();
  const middle = $('mname').value.trim();
  const last = $('lname').value.trim();
  const noMiddle = $('noMiddle').checked;
  const err = $('formErr');
  err.classList.remove('show');

  if (!first || !last) {
    err.textContent = "First and last name are required to run the engine.";
    err.classList.add('show'); return;
  }
  if (!middle && !noMiddle) {
    err.textContent = "Middle name is required. If none exists on your birth record, confirm the checkbox below the field.";
    err.classList.add('show'); return;
  }
  if (inputBlocked(first) || inputBlocked(middle) || inputBlocked(last)) {
    err.textContent = "The engine reads birth names only. Enter your name as it appears on your record.";
    err.classList.add('show'); return;
  }

  const result = executeDivinetixEngineV2(first, middle, last);
  if (!result) {
    err.textContent = "The engine could not parse the name signature. Use alphabetic characters only.";
    err.classList.add('show'); return;
  }

  runRevelationSequence(first, middle, last, result);
});

function runRevelationSequence(first, middle, last, result){
  show('proc');
  const linesEl = $('procLines');
  linesEl.innerHTML = '';
  const lineEls = procSteps.map(txt => {
    const d = document.createElement('div');
    d.className = 'proc-line';
    d.innerHTML = '<span>' + txt + '</span><span class="st">·</span>';
    linesEl.appendChild(d);
    return d;
  });

  const fullName = (first + middle + last).toUpperCase().replace(/[^A-Z]/g,'');
  const ticker = $('ticker');
  const bar = $('barFill');
  const total = stepDur.reduce((a,b)=>a+b,0);
  const speed = reduceMotion ? 0.18 : 1;   // compress sequence if user prefers reduced motion
  let elapsed = 0, i = 0;

  function runStep(){
    if (i > 0){
      lineEls[i-1].classList.remove('running');
      lineEls[i-1].classList.add('done');
      lineEls[i-1].querySelector('.st').textContent = 'OK';
    }
    if (i >= procSteps.length){
      ticker.innerHTML = '<b>SIGNATURE COMPILED</b>';
      pendingRender = { first, middle, last, result };
      setTimeout(() => {
        if (gateDone) { renderDashboard(first, middle, last, result); }
        else { show('gate'); }
      }, 500 * speed);
      return;
    }
    lineEls[i].classList.add('running');
    lineEls[i].querySelector('.st').textContent = 'RUN';

    if (i === 0) letterTicker(fullName, stepDur[0] * speed);
    if (i === 4) ticker.innerHTML = 'T = <b>' + new Date().toISOString() + '</b>';
    if (i === 5) ticker.innerHTML = 'FIELD POSITION <b>' + result.phasePosition + '</b> · MODIFIER LOCKED';

    elapsed += stepDur[i];
    bar.style.width = Math.round(elapsed / total * 100) + '%';
    setTimeout(runStep, stepDur[i] * speed);
    i++;
  }
  bar.style.width = '0%';
  runStep();
}

function letterTicker(name, duration){
  const ticker = $('ticker');
  const per = Math.max(30, duration / (name.length + 1));
  let idx = 0, sum = 0;
  const iv = setInterval(() => {
    if (idx >= name.length){ clearInterval(iv); return; }
    sum += pythagorean[name[idx]] || 0;
    ticker.innerHTML = name.slice(0, idx + 1).split('').join(' ') + ' &nbsp;→&nbsp; Σ <b>' + sum + '</b>';
    idx++;
  }, per);
}

  const variantMap = {
    
      "1": "52330845044917",
    
      "2": "52330845143221",
    
      "3": "52330845241525",
    
      "4": "52330845339829",
    
      "5": "52330845438133",
    
      "6": "52330845536437",
    
      "7": "52330845634741",
    
      "8": "52330845733045",
    
      "9": "52330845831349",
    
      "10": "52330845929653",
    
      "11": "52330846027957",
    
      "12": "52330846126261"
    
  }

function updateCtaHref(rootValue) {
  const variantId = variantMap[rootValue];
  const ctaButton = document.querySelector('#ctaBuy'); 

  if (variantId && ctaButton) {
    // Set the attribute using standard vanilla JS
    ctaButton.setAttribute('href', `/cart/${variantId}:1`);
  } else {
    console.warn(`Variant or CTA button not found for root value: ${rootValue}`);
  }
}

function renderDashboard(first, middle, last, r){
  $('subjName').textContent = 'SUBJECT: ' + [first, middle, last].filter(Boolean).join(' ').toUpperCase();

  $('mSeed').innerHTML = r.seed + '<small>/ 9</small>';
  $('mPotential').innerHTML = r.potential + '<small>/ 22</small>';
  $('mRoot').innerHTML = r.root + '<small>/ 12</small>';
  $('mTruth').innerHTML = r.truthHunter + '<small>/ 9</small>';
  const asset = $('mAsset');
  asset.textContent = r.assetType.toUpperCase();
  asset.className = 'badge ' + (r.assetType === 'Fixed Asset' ? 'fixed' : 'liquid');
  $('mBase').textContent = r.baseRatio.toFixed(2);

  // Field ring: arc length maps phasePosition 0→1 around the circle; dot marks position
  const p = parseFloat(r.phasePosition);
  const C = 2 * Math.PI * 38;
  const arc = $('ringArc');
  arc.setAttribute('stroke-dasharray', (C * p).toFixed(1) + ' ' + C.toFixed(1));
  const ang = p * 2 * Math.PI - Math.PI / 2;
  $('ringDot').setAttribute('cx', 46 + 38 * Math.cos(ang));
  $('ringDot').setAttribute('cy', 46 + 38 * Math.sin(ang));
  $('fieldNum').textContent = r.phasePosition;
  $('fieldName').textContent = getFieldState(parseFloat(r.phasePosition));

  const face = resolveActiveFace(r);
  const mod = parseFloat((r.activeRatio - r.baseRatio).toFixed(2));
  $('tempNum').textContent = r.activeRatio.toFixed(2);
  $('tempEq').textContent = r.baseRatio.toFixed(2) + ' base ' + (mod >= 0 ? '+ ' : '− ') + Math.abs(mod).toFixed(2) + ' field';
  const tag = $('tempTag');
  let cls, label;
  if (face === 'Loud Expression'){ cls = 't-hot'; label = 'HOT / VOLATILE'; }
  else if (face === 'Quiet Expression'){ cls = 't-cold'; label = 'COLD / STABLE'; }
  else { cls = 't-neutral'; label = 'NEUTRAL / MID-BAND'; }
  tag.className = 'temp-tag ' + cls;
  tag.textContent = label;

  const faceEl = $('faceName');
  faceEl.textContent = face.toUpperCase();
  faceEl.className = 'face-name ' + (cls === 't-hot' ? 'f-hot' : cls === 't-cold' ? 'f-cold' : 'f-neutral');
  $('faceNote').textContent = faceNotes[face];

  const w = todaysWindow[face];
  $('windowStrip').className = 'window-strip ' + w.cls;
  $('windowVerb').textContent = w.verb;
  $('windowLine').textContent = w.line;

  $('govName').textContent = r.governor;
  const pv = rootPreviews[r.root];
  $('ledgerTag').textContent = 'CARRYING: ' + pv.ledger;
  $('rootText').textContent = pv.carry;
  $('debtText').textContent = pv.debt;
  $('storageText').textContent = pv.storage.toUpperCase();

  lastAudit = { root: r.root, face: face };
  renderBand(r, face);
  renderSignatureCard(first, middle, last, r, face, pv);

  document.querySelectorAll('#rateBtns button').forEach(b => b.classList.remove('sel'));
  $('rateDone').style.display = 'none';
  updateCtaHref(r.root);

  show('dash');
}

$('rerunBtn').addEventListener('click', () => {
  $('ticker').textContent = '';
  show('input');
});

// Wire to Shopify checkout (variant keyed by Root 1-12) and consultation application:
// $('ctaBuy').addEventListener('click', e => e.preventDefault());
 $('ctaConsult').addEventListener('click', e => e.preventDefault());

// Soft gate: capture is optional, skip is always visible.
$('gateBtn').addEventListener('click', () => {
  const email = $('gateEmail').value.trim();
  const err = $('gateErr');
  err.classList.remove('show');
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    err.textContent = 'Enter a valid address, or use the skip link below.';
    err.classList.add('show'); return;
  }
  if (pendingRender) postToSheet({ type:'gate', email: email,
    name: [pendingRender.first, pendingRender.middle, pendingRender.last].filter(Boolean).join(' '),
    root: pendingRender.result.root });
  gateDone = true;
  if (pendingRender) renderDashboard(pendingRender.first, pendingRender.middle, pendingRender.last, pendingRender.result);
});
$('gateSkip').addEventListener('click', () => {
  gateDone = true;
  if (pendingRender) renderDashboard(pendingRender.first, pendingRender.middle, pendingRender.last, pendingRender.result);
});

// Expression Band: the person's baseline, today's position, and the three Face zones.
function renderBand(r, face){
  const base = r.baseRatio, cur = r.activeRatio;
  const lo = base - 0.22, hi = base + 0.22;
  const inBand = base > 0.70 && base < 1.15;
  const qEnd = inBand ? 0.85 : base - 0.08;
  const lStart = inBand ? 1.00 : base + 0.05;
  const X = v => 20 + (Math.min(Math.max(v, lo), hi) - lo) / (hi - lo) * 520;
  const y = 42, h = 16;
  let out = '';
  out += '<rect x="'+X(lo)+'" y="'+y+'" width="'+Math.max(0, X(qEnd)-X(lo))+'" height="'+h+'" fill="rgba(125,211,252,.16)"/>';
  out += '<rect x="'+X(qEnd)+'" y="'+y+'" width="'+Math.max(0, X(lStart)-X(qEnd))+'" height="'+h+'" fill="rgba(163,179,201,.14)"/>';
  out += '<rect x="'+X(lStart)+'" y="'+y+'" width="'+Math.max(0, X(hi)-X(lStart))+'" height="'+h+'" fill="rgba(245,158,11,.16)"/>';
  const zone = (a,b,label,color) => {
    if (X(b)-X(a) > 46) out += '<text x="'+((X(a)+X(b))/2)+'" y="'+(y-8)+'" fill="'+color+'" font-size="9" font-family="ui-monospace,Menlo,monospace" text-anchor="middle" letter-spacing="1.5">'+label+'</text>';
  };
  zone(lo,qEnd,'QUIET','#7dd3fc'); zone(qEnd,lStart,'THIRD','#a3b3c9'); zone(lStart,hi,'LOUD','#f59e0b');
  out += '<line x1="'+X(base)+'" y1="'+(y-4)+'" x2="'+X(base)+'" y2="'+(y+h+4)+'" stroke="#64748b" stroke-width="2"/>';
  out += '<text x="'+X(base)+'" y="'+(y+h+18)+'" fill="#64748b" font-size="9" font-family="ui-monospace,Menlo,monospace" text-anchor="middle" letter-spacing="1.5">BASE '+base.toFixed(2)+'</text>';
  out += '<circle cx="'+X(cur)+'" cy="'+(y+h/2)+'" r="6" fill="#f8fafc"/>';
  out += '<text x="'+X(cur)+'" y="'+(y+h+32)+'" fill="#f8fafc" font-size="9" font-family="ui-monospace,Menlo,monospace" text-anchor="middle" letter-spacing="1.5">TODAY '+cur.toFixed(2)+'</text>';
  $('bandSvg').innerHTML = out;
}

// Signature Card: built for screenshots and trading. tefillah.io on every card.
function renderSignatureCard(first, middle, last, r, face, pv){
  const fc = face === 'Loud Expression' ? '#f59e0b' : face === 'Quiet Expression' ? '#7dd3fc' : '#a3b3c9';
  const d = new Date();
  const pulled = ('0'+(d.getMonth()+1)).slice(-2)+'.'+('0'+d.getDate()).slice(-2)+'.'+d.getFullYear();
  const name = [first, middle, last].filter(Boolean).join(' ').toUpperCase();
  const M = 'ui-monospace,Menlo,Consolas,monospace';
  const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 800">'
    + '<rect width="600" height="800" fill="#0f172a"/>'
    + '<rect x="14" y="14" width="572" height="772" rx="18" fill="none" stroke="#334155" stroke-width="2"/>'
    + '<text x="300" y="72" fill="#f8fafc" font-family="'+M+'" font-size="17" font-weight="700" text-anchor="middle" letter-spacing="4">TEFILLAH</text>'
    + '<text x="300" y="98" fill="#64748b" font-family="'+M+'" font-size="11" text-anchor="middle" letter-spacing="3">THE NAME AUDIT™</text>'
    + '<line x1="60" y1="126" x2="540" y2="126" stroke="#26334a"/>'
    + '<text x="300" y="170" fill="#64748b" font-family="'+M+'" font-size="12" text-anchor="middle" letter-spacing="3">ROOT</text>'
    + '<text x="300" y="278" fill="#f8fafc" font-family="'+M+'" font-size="108" font-weight="700" text-anchor="middle">'+r.root+'</text>'
    + '<text x="300" y="306" fill="#64748b" font-family="'+M+'" font-size="12" text-anchor="middle" letter-spacing="2">OF 12</text>'
    + '<text x="300" y="368" fill="#f8fafc" font-family="'+M+'" font-size="26" font-weight="700" text-anchor="middle" letter-spacing="2">'+pv.ledger+'</text>'
    + '<text x="300" y="398" fill="#94a3b8" font-family="'+M+'" font-size="12" text-anchor="middle" letter-spacing="2">'+r.governor.toUpperCase()+'</text>'
    + '<line x1="60" y1="432" x2="540" y2="432" stroke="#26334a"/>'
    + '<text x="150" y="466" fill="#64748b" font-family="'+M+'" font-size="10" text-anchor="middle" letter-spacing="2">SEED</text>'
    + '<text x="150" y="500" fill="#f8fafc" font-family="'+M+'" font-size="28" font-weight="700" text-anchor="middle">'+r.seed+'</text>'
    + '<text x="300" y="466" fill="#64748b" font-family="'+M+'" font-size="10" text-anchor="middle" letter-spacing="2">POTENTIAL</text>'
    + '<text x="300" y="500" fill="#f8fafc" font-family="'+M+'" font-size="28" font-weight="700" text-anchor="middle">'+r.potential+'</text>'
    + '<text x="450" y="466" fill="#64748b" font-family="'+M+'" font-size="10" text-anchor="middle" letter-spacing="2">TRUTH-HUNTER</text>'
    + '<text x="450" y="500" fill="#f8fafc" font-family="'+M+'" font-size="28" font-weight="700" text-anchor="middle">'+r.truthHunter+'</text>'
    + '<rect x="150" y="546" width="300" height="46" rx="8" fill="none" stroke="'+fc+'"/>'
    + '<text x="300" y="575" fill="'+fc+'" font-family="'+M+'" font-size="15" font-weight="700" text-anchor="middle" letter-spacing="2">'+face.toUpperCase()+'</text>'
    + '<text x="300" y="628" fill="#94a3b8" font-family="'+M+'" font-size="11" text-anchor="middle" letter-spacing="2">FIELD '+r.phasePosition+' · '+getFieldState(parseFloat(r.phasePosition))+'</text>'
    + '<text x="300" y="658" fill="#475569" font-family="'+M+'" font-size="10" text-anchor="middle" letter-spacing="3">PULLED '+pulled+'</text>'
    + '<text x="300" y="700" fill="#64748b" font-family="'+M+'" font-size="11" text-anchor="middle" letter-spacing="2">'+name+'</text>'
    + '<text x="300" y="756" fill="#7dd3fc" font-family="'+M+'" font-size="13" font-weight="700" text-anchor="middle" letter-spacing="3">TEFILLAH.IO</text>'
    + '</svg>';
  $('sigCardHolder').innerHTML = svg;
}

$('cardBtn').addEventListener('click', () => {
  const svgEl = document.querySelector('#sigCardHolder svg');
  if (!svgEl) return;
  const xml = new XMLSerializer().serializeToString(svgEl);
  const blob = new Blob([xml], {type: 'image/svg+xml;charset=utf-8'});
  const url = URL.createObjectURL(blob);
  const img = new Image();
  img.onload = () => {
    const c = document.createElement('canvas');
    c.width = 1200; c.height = 1600;
    c.getContext('2d').drawImage(img, 0, 0, 1200, 1600);
    URL.revokeObjectURL(url);
    const a = document.createElement('a');
    a.download = 'tefillah-signature-card.png';
    a.href = c.toDataURL('image/png');
    a.click();
  };
  img.src = url;
});

// Resonance rating. wire to backend; show live aggregate only once data is real.
$('rateBtns').addEventListener('click', e => {
  const btn = e.target.closest('button');
  if (!btn) return;
  document.querySelectorAll('#rateBtns button').forEach(b => b.classList.remove('sel'));
  btn.classList.add('sel');
  if (lastAudit) postToSheet({ type:'rating', rating: btn.dataset.v, root: lastAudit.root, face: lastAudit.face });
  $('rateDone').style.display = 'block';
});

// Optional signature save. wire to ESP / Shopify customer record.
$('saveBtn').addEventListener('click', () => {
  const email = $('saveEmail').value.trim();
  const err = $('saveErr');
  err.classList.remove('show');
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    err.textContent = 'Enter a valid address to link your signature.';
    err.classList.add('show'); return;
  }
  if (lastAudit) postToSheet({ type:'save', email: email,
    name: $('subjName').textContent.replace('SUBJECT: ',''), root: lastAudit.root });
  $('saveDone').style.display = 'block';
  $('saveEmail').disabled = true; $('saveBtn').disabled = true;
});

/* URL-param persistence. deterministic engine: a delivered link like
   ?f=Dwayne&m=Christopher&l=Scott re-renders instantly on return visits
   (fresh field position, same signature) without re-running the sequence. */
(function initFromParams(){
  const q = new URLSearchParams(location.search);
  const f = q.get('f'), l = q.get('l'), m = q.get('m') || '';
  if (f && l) {
    const r = executeDivinetixEngineV2(f, m, l);
    if (r) { gateDone = true; renderDashboard(f, m, l, r); }
  }
})();